var map = {
	"./DashingDerbyIcon.svg": 4934,
	"./LuckyLoot624Icon.svg": 3424,
	"./MotorRacingIcon.svg": 9397,
	"./PlatinumHoundsIcon.svg": 4200,
	"./SmartPlayKenoIcon.svg": 4103,
	"./SpinAndWinIcon.svg": 7033,
	"./logo.svg": 9574,
	"./quick.svg": 9209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;